import { g as gsapWithCSS, S as ScrollTrigger } from "@theme/theme";
gsapWithCSS.registerPlugin(ScrollTrigger);
class TabsTextImageComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      tabBtns: this.querySelectorAll(".js-tab-button"),
      tabContent: this.querySelectorAll(".js-tab-content"),
      firstLottie: this.querySelector(".js-tab-content.is-active c-lottie")
    };
    this.scrollTrigger = null;
  }
  connectedCallback() {
    this.bindEvents();
    this.playFirstLottie();
  }
  bindEvents() {
    this.DOM.tabBtns.forEach((btn) => {
      btn.addEventListener("click", this.tabBtnClick.bind(this));
    });
  }
  playFirstLottie() {
    if (!this.DOM.firstLottie) return;
    this.scrollTrigger = ScrollTrigger.create({
      trigger: this,
      start: "top bottom",
      once: true,
      markers: false,
      onEnter: async () => {
        await window.customElements.whenDefined("c-lottie");
        this.DOM.firstLottie.play();
      }
    });
  }
  disablePlayFirstLottie() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill();
      this.scrollTrigger = null;
    }
  }
  tabBtnClick(e) {
    this.disablePlayFirstLottie();
    const currentBtn = e.currentTarget;
    const index = currentBtn.getAttribute("data-index");
    const currentContent = this.DOM.tabContent[index];
    if (currentBtn.classList.contains("is-active") || !currentContent) return;
    const activeBtn = this.querySelector(".js-tab-button.is-active");
    const activeContent = this.querySelector(".js-tab-content.is-active");
    activeBtn.classList.remove("is-active");
    currentBtn.classList.add("is-active");
    activeContent.classList.remove("is-active");
    currentContent.classList.add("is-active");
    gsapWithCSS.delayedCall(0.5, () => {
      const activeLottieElement = activeContent.querySelector("c-lottie");
      const currentLottieElement = currentContent.querySelector("c-lottie");
      if (activeLottieElement) {
        activeLottieElement.stop();
      }
      if (currentLottieElement) {
        currentLottieElement.play();
      }
    });
  }
}
window.customElements.define("c-tabs-text-image", TabsTextImageComponent);
